<template>
<div class="chapter">
<div class="inner_page">
<h1>Rustic Elegance</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Preface</a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">The Eyes of an Artist </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">High Encampment</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Cutthroat Cabin</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Double D Ranch</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Mirror Pond Cabin</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">El Rancho</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">House Mountain</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Skyart Lodge</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">Pond Cabin</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch11" title="Link target outside of Sample">Lone Moose Lodge</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch12" title="Link target outside of Sample">The Pointe</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch13" title="Link target outside of Sample">Two Eagle Ranch</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch14" title="Link target outside of Sample">Whitefish Retreat</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch15" title="Link target outside of Sample">The Hideaway</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch16" title="Link target outside of Sample">Resources</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?51adf252